<template>
    <div>

        <!-- mensajes de confirmacion -->
       
        <mensajeSistema></mensajeSistema>
        <v-container v-if="!estadoComponente" >

            <!-- fin boton  crear-->

            <!-- /////////////////////////////////////////////////////
                //             PANTALLA PRINCIPAL DE NOTICIA      //
                /////////////////////////////////////////////////////    -->
            <v-card>
                
                <v-row class="px-2">
                    <v-col  cols="4"  class="pb-6">
                        <v-text-field label="Buscar" v-model="search" dense append-icon="fa-search" single-line hide-details ></v-text-field>
                    </v-col>               
                            
                    <v-col class="d-flex justify-end" >
                        <v-btn class="btn_block_style2" dark tile @click="addItem"  v-if="componenteEvento.agregar_submodulo">Crear noticas</v-btn>
                    </v-col>
                </v-row>

                <v-data-table :headers="headers" :items="Datos" :search="search" dense :sort-by="['desc_noticia_categoria']" :sort-desc="[false]" class="elevation-1 black--text" fixed-header>

                    <template v-slot:[`item.action_titulo`]="{ item }">
                        <span v-html="item.titulo.replace(/(<([^>]+)>)/gi, '')"></span>
                    </template>


                    <template v-slot:[`item.fec_us_ing`] ="{ item }">
                        {{item.fec_us_ing | filtroFecha }}
                    </template>

                    <template v-slot:[`item.fec_us_mod`] ="{ item }">
                        {{item.fec_us_mod | filtroFecha }}
                    </template>


                    <template v-slot:[`item.estadoValor`] ="{ item }">
                        <v-chip v-if="item.estado_noticia===true" small class="color_activo">
                            Activo
                        </v-chip>
                        <v-chip  v-if="item.estado_noticia===false" small class="mr-2 color_inactivo">
                            Inactivo
                        </v-chip>
                    </template>


                    <template v-slot:[`item.action_editar`] ="{ item }">
                        <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                                <span v-on="on" class="fa-stack fa-1x" style="cursor: pointer"   @click="editItem(item)">
                                    <i class="fas fa-circle fa-stack-2x icolor_edit"></i>
                                    <i class="fas fa-pencil-alt fa-stack-1x fa-inverse"></i>
                                </span>
                            </template>
                            <span>EDITAR NOTICIA</span>
                        </v-tooltip>
                    </template>

                    <template v-slot:[`item.action_borrar`] ="{ item }">
                        <v-tooltip bottom color="#1b1b1b">                        
                            <template v-slot:activator="{ on }">
                                <span v-on="on" class="fa-stack fa-1x" style="cursor: pointer" @click="eventConfirm(item)">
                                    <i class="fas fa-circle fa-stack-2x icolor_delete"></i>
                                    <i class="fas fa-trash-alt fa-stack-1x fa-inverse "></i>
                                </span>
                            </template>
                            <span>BORRAR NOTICIA</span>
                        </v-tooltip>
                    </template>

                    
                </v-data-table>
            </v-card>
        <!-- fin de pantalla principal -->

        </v-container>


        <!-- COMPONENTES -->

        <v-container v-if="estadoComponente">

            <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" 
                @reloadComp="reloadComp" @close="estadoComponente=false" >
            </component>

        </v-container>




              <confirm :active="confirm.active" :title="confirm.title" 
                        :highlight="confirm.highlight" :titleEnd="confirm.titleEnd"
                        @accept="deleteItem" @cancel="clearConfirm" />
            
        <!-- fin de componenestes  -->
        <span v-if="test">
            <code>
                Datos :{{Datos}} 
            </code>
            <br>
            <code>
                Session :{{session}} 
            </code>
             <code>
                Session Empresa :{{session.id_empresa}} 
            </code>
           
        </span>

    </div>
</template>



<script>
    import axios from '@/helpers/axios'
    import {mapMutations, mapGetters, mapActions} from 'vuex';
    import noticiaFormComp from './NoticiaFormComp'

    import Vue from "vue";
    import CKEditor from "ckeditor4-vue";
     Vue.use( CKEditor )
    export default {

        name:"Noticia",
        components:{
            noticiaFormComp
        },

        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{ "id_modulo": 2000, 'id_submodulo':2210}, //sud_modulo y modulo
            session: sessionStorage, // variables de sesion del usuario
            ////////////////////////////////////////////////////////
            test :false,
            Datos:[],

            compName:"",
            estadoComponente:   false,
            parametroComp : {},

            
            confirm: {
                title: "",
                highligh:"",
                titleEnd:"",
                active: false,
                procedencia:"",
                parms :{}
            },

            search:'',

            headers: [
                { text: 'ID', align: 'left', value: 'id', class:'secondary'},
                { text: 'NOTICIA', value: 'action_titulo', class:'secondary black--text' },
                { text: 'CATEGORIA', value: 'desc_noticia_categoria', class:'secondary black--text' },
                { text: 'FECHA CREACIÓN', value: 'fec_us_ing', class:'secondary black--text' },
                { text: 'FEC. MODIFICACIÓN', value: 'fec_us_mod', class:'secondary black--text' },
                { text: 'ESTADO', value: 'estadoValor', sortable: false, align: 'center', class:'secondary black--text'},
                { text: 'EDITAR', value: 'action_editar', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'60'},
                { text: 'BORRAR', value: 'action_borrar', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'60'},
                
            ],

            
        }),


        computed: {
            ...mapGetters('login', [ 'componenteEvento'])
        },

        mounted() {
            this.loadMain()
        },

        created(){
            this.actualizarParamentro()
        },


        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //----- Validar accesos por perfil ------------
            ...mapActions('login',['parametroComponente'] ),

            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////


            //  ------- Cargar todos los registros principales al iniciar el componente   --------
            async loadMain(){
                try{
                    let params ={id_empresa: this.session.id_empresa }
                    let response = await axios.post("/website/noticia/get",{filtro:params})
                    this.Datos = response.data;
                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
            },



            addItem(){
                this.parametroComp = {evento:"agregar"}
                this.compName = "noticiaFormComp"
                this.estadoComponente = true
            },

            editItem (item) {
                this.parametroComp = {evento:"editar",item} 
                this.compName = "noticiaFormComp"
                this.estadoComponente = true
            },


            reloadComp(procedencia){
                console.debug(procedencia)                
                this.loadMain()
                this.estadoComponente=false
            },


            // activa la modal para confirmar el borrar el registro
            
            eventConfirm(item) {
                this.confirm.params      =  item 
                this.confirm.active      = true;
                this.confirm.procedencia = "tema";
                this.confirm.title       = "¿Está seguro que desea borrar este registro?";
                this.confirm.highlight   = ""
                this.confirm.titleEnd    = " ?";
            },


            //------------BORRAR Registro -------------
            async deleteItem() {

                this.dialog_delete = false
                try{
                    let resp = await axios.delete("/website/noticia/"+this.confirm.params.id)
                    this.clearConfirm()
                    this.loadMain()
                    this.setEnviarMens({tipo:resp.data.messageT, mensaje: resp.data.message, tiempo:null})
                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
            },

            clearConfirm() {
                this.confirm.params    = {}, 
                this.confirm.title = ""
                this.confirm.active = false
                this.confirm.procedencia = ""
                this.confirm.highlight = ""
                this.confirm.titleEnd = ""
            },


             

        },
    }
</script>